import { animate, group, query, style, transition, trigger } from '@angular/animations';
const RESET_ROUTE_ANIMATION = [
  style({ position: 'relative' }),
  query(
    ':enter, :leave',
    [
      style({
        position: 'absolute', // using absolute makes the scroll get stuck in the previous page's scroll position on the new page
        top: 0, // adjust this if you have a header so it factors in the height and not cause the router outlet to jump as it animates
        left: 0,
        width: '100%',
        height: '100%'
      })
    ],
    { optional: true }
  )
];

// Fade Animation
export const ROUTE_ANIMATION = trigger('routeAnimation', [
  transition('* => *', [
    ...RESET_ROUTE_ANIMATION,
    group([
      query(
        ':leave',
        [
          style({ opacity: 1, transform: 'translateX(0)', transformOrigin: 'left center' }),
          animate('.250s', style({ opacity: 0, transform: 'translateX(-5%)' }))
        ],
        {
          optional: true
        }
      ),
      query(
        ':enter',
        [
          style({ opacity: 0, transform: 'translateX(-25%)', transformOrigin: 'right center' }),
          animate('.45s', style({ opacity: 1, transform: 'translateX(0)' }))
        ],
        {
          optional: true
        }
      )
    ])
  ])
]);
